interface SocialIconProps {
  size?: number;
  inherit?: boolean;
}

const Discord = ({ size = 20, inherit = false }: SocialIconProps) => (
  <svg
    className="flex-shrink-0"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Discord"
  >
    <g clipPath="url(#clip0_4325_6020)">
      <path
        d="M12.2287 4C12.074 4.27466 11.9351 4.5588 11.8088 4.84925C10.6091 4.6693 9.38735 4.6693 8.18451 4.84925C8.06139 4.5588 7.91931 4.27466 7.76462 4C6.63755 4.19259 5.53889 4.53039 4.49706 5.0071C2.43234 8.0663 1.87354 11.0466 2.15136 13.9858C3.36051 14.8792 4.7149 15.5612 6.15767 15.9968C6.48285 15.5612 6.77015 15.0971 7.0164 14.614C6.54915 14.4404 6.09769 14.2226 5.66517 13.97C5.77882 13.8879 5.88932 13.8027 5.99666 13.7206C8.53179 14.914 11.4679 14.914 14.0061 13.7206C14.1135 13.809 14.224 13.8942 14.3376 13.97C13.9051 14.2257 13.4536 14.4404 12.9832 14.6172C13.2295 15.1002 13.5168 15.5643 13.842 16C15.2847 15.5643 16.6391 14.8855 17.8483 13.9921C18.1766 10.5825 17.2863 7.62746 15.4962 5.01026C14.4576 4.53355 13.3589 4.19574 12.2319 4.00631L12.2287 4ZM7.36999 12.1768C6.5902 12.1768 5.943 11.4696 5.943 10.5951C5.943 9.72061 6.56494 9.01026 7.36684 9.01026C8.16874 9.01026 8.80645 9.72376 8.79382 10.5951C8.7812 11.4665 8.16557 12.1768 7.36999 12.1768ZM12.6297 12.1768C11.8467 12.1768 11.2058 11.4696 11.2058 10.5951C11.2058 9.72061 11.8278 9.01026 12.6297 9.01026C13.4316 9.01026 14.0661 9.72376 14.0535 10.5951C14.0409 11.4665 13.4252 12.1768 12.6297 12.1768Z"
        fill={inherit ? 'currentColor' : 'white'}
      />
    </g>
    <defs>
      <clipPath id="clip0_4325_6020">
        <rect width="15.8305" height="12" fill="white" transform="translate(2.08496 4)" />
      </clipPath>
    </defs>
  </svg>
);

const Instagram = ({ size = 20, inherit = false }: SocialIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Instagram"
  >
    <g clipPath="url(#clip0_6046_4456)">
      <path
        d="M14.1665 1.66663H5.83317C3.53198 1.66663 1.6665 3.53211 1.6665 5.83329V14.1666C1.6665 16.4678 3.53198 18.3333 5.83317 18.3333H14.1665C16.4677 18.3333 18.3332 16.4678 18.3332 14.1666V5.83329C18.3332 3.53211 16.4677 1.66663 14.1665 1.66663Z"
        stroke={inherit ? 'currentColor' : 'white'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3337 9.47501C13.4366 10.1685 13.3181 10.8769 12.9952 11.4992C12.6723 12.1215 12.1614 12.6262 11.5351 12.9414C10.9088 13.2566 10.1991 13.3663 9.5069 13.255C8.81468 13.1436 8.17521 12.8167 7.67944 12.321C7.18367 11.8252 6.85685 11.1857 6.74546 10.4935C6.63408 9.8013 6.74379 9.09159 7.05901 8.46532C7.37423 7.83905 7.8789 7.32812 8.50123 7.00521C9.12356 6.68229 9.83187 6.56383 10.5254 6.66667C11.2328 6.77158 11.8878 7.10123 12.3935 7.60693C12.8992 8.11263 13.2288 8.76757 13.3337 9.47501Z"
        stroke={inherit ? 'currentColor' : 'white'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5835 5.41663H14.5918"
        stroke={inherit ? 'currentColor' : 'white'}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6046_4456">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TikTok = ({ size = 20, inherit = false }: SocialIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="TikTok"
  >
    <path
      d="M10.4101 0.643066C11.4332 0.627441 12.4488 0.635566 13.4638 0.627441C13.4976 1.89682 14.0126 3.03932 14.8319 3.88557L14.8307 3.88432C15.7126 4.67869 16.8601 5.19369 18.1251 5.28119L18.1426 5.28244V8.42994C16.9476 8.39994 15.8238 8.12432 14.8107 7.65057L14.8619 7.67182C14.3719 7.43619 13.9576 7.19432 13.5638 6.92432L13.5963 6.94557C13.5888 9.22619 13.6038 11.5068 13.5807 13.7793C13.5163 14.9374 13.1313 15.9937 12.5138 16.8756L12.5263 16.8562C11.4938 18.3349 9.82131 19.3056 7.91944 19.3631H7.91069C7.83382 19.3668 7.74319 19.3687 7.65194 19.3687C6.57069 19.3687 5.56007 19.0674 4.69882 18.5443L4.72382 18.5587C3.15632 17.6156 2.07507 16.0018 1.87507 14.1249L1.87257 14.0993C1.85694 13.7087 1.84944 13.3181 1.86507 12.9356C2.17132 9.94869 4.67382 7.63807 7.71569 7.63807C8.05757 7.63807 8.39257 7.66744 8.71819 7.72307L8.68319 7.71807C8.69881 8.87369 8.65194 10.0299 8.65194 11.1856C8.38757 11.0899 8.08257 11.0343 7.76444 11.0343C6.59694 11.0343 5.60382 11.7806 5.23632 12.8224L5.23069 12.8412C5.14757 13.1081 5.09944 13.4149 5.09944 13.7324C5.09944 13.8612 5.10757 13.9887 5.12257 14.1137L5.12132 14.0987C5.32882 15.3774 6.42507 16.3424 7.74694 16.3424C7.78507 16.3424 7.82257 16.3418 7.86007 16.3399H7.85444C8.76882 16.3124 9.56256 15.8206 10.0113 15.0937L10.0176 15.0824C10.1844 14.8499 10.2988 14.5687 10.3369 14.2631L10.3376 14.2543C10.4157 12.8562 10.3844 11.4662 10.3919 10.0681C10.3994 6.92057 10.3844 3.78057 10.4076 0.641191L10.4101 0.643066Z"
      fill={inherit ? 'currentColor' : 'white'}
    />
  </svg>
);

const Youtube = ({ size = 20, inherit = false }: SocialIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Youtube"
  >
    <g clipPath="url(#clip0_6046_4529)">
      <g clipPath="url(#clip1_6046_4529)">
        <path
          d="M10.0713 4C10.1165 4.00001 15.438 4.0015 16.7686 4.3584C17.5063 4.55606 18.0857 5.13618 18.2832 5.87402C18.6401 7.21001 18.6416 9.99866 18.6416 10C18.6416 10 18.6416 12.7897 18.2832 14.126C18.0857 14.8638 17.5063 15.444 16.7686 15.6416C15.438 15.9985 10.1165 16 10.0713 16C10.0713 16 4.71049 16 3.37402 15.6416C2.63602 15.4441 2.05595 14.864 1.8584 14.126C1.50001 12.7896 1.5 10 1.5 10C1.5 9.99906 1.50006 7.21014 1.8584 5.87402C2.05595 5.13602 2.63602 4.55595 3.37402 4.3584C4.71048 4 10.0713 4 10.0713 4ZM8.35547 12.5713L12.8086 10L8.35547 7.42969V12.5713Z"
          fill={inherit ? 'currentColor' : 'white'}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6046_4529">
        <rect width="17.142" height="12" fill="white" transform="translate(1.5 4)" />
      </clipPath>
      <clipPath id="clip1_6046_4529">
        <rect width="17.142" height="12" fill="white" transform="translate(1.5 4)" />
      </clipPath>
    </defs>
  </svg>
);

const Facebook = ({ size = 20, inherit = false }: SocialIconProps) => (
  <svg
    className="flex-shrink-0"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Facebook"
  >
    <path
      d="M14.1667 1.99988H11.6667C10.5616 1.99988 9.50179 2.43886 8.72039 3.22027C7.93899 4.00167 7.5 5.06148 7.5 6.16654V8.66654H5V11.9999H7.5V18.6665H10.8333V11.9999H13.3333L14.1667 8.66654H10.8333V6.16654C10.8333 5.94553 10.9211 5.73357 11.0774 5.57729C11.2337 5.42101 11.4457 5.33321 11.6667 5.33321H14.1667V1.99988Z"
      fill={inherit ? 'currentColor' : 'white'}
    />
  </svg>
);

const Github = ({ size = 20, inherit = false }: SocialIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 98 96"
    aria-label="Github"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z"
      fill={inherit ? 'currentColor' : '#fff'}
    />
  </svg>
);
export { Discord, Facebook, Github, Instagram, TikTok, Youtube };
